module.exports = __webpack_public_path__ + "resource/static/img/icon12@1.5x.1678777.png";


//////////////////
// WEBPACK FOOTER
// ./static/img1/icon12@1.5x.png
// module id = kXBP
// module chunks = 1